<template>
    <!-- Selecting game modal -->
    <popup-modal show>
        <template #content>
            <div>
                <p class="message">Hier onder staan alle actieve spellen, je kunt ze <b> bekijken</b> of een <b>nieuwe starten</b></p>
            </div>
            <div class="games-wrapper flex-column-gap">
                <div v-for="game in sortedGames" class="game-preview" @click="handleSelectGame(game.id)">
                    <div class="content">
                        <div class="users-with-scores">
                            <div v-for="user in game.users" :key="user.id" class="user">
                                <div class="left">
                                    <avatar class="avatar" :userId="user.id" :avatar="user.base64avatar"></avatar>
                                    <b v-parse-emojis>{{ user.name }}</b>
                                </div>
                                <b class="score">{{ user.displayScore }}</b>
                            </div>
                        </div>
                        <p class="creation-date">{{ getTime(game.creationDate) }} aangemaakt</p>
                    </div>
                    <div class="footer message">
                        <p>Spel bekijken</p>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <custom-button size="medium" @click="$emit('startNewGame')">Nieuw spel starten</custom-button>
        </template>
    </popup-modal>
</template>

<script>
import PopupModal from '@/components/PopupModal.vue';
import CustomButton from '@/components/CustomButton.vue';
import Avatar from '@/components/Avatar.vue';

export default {
    name: 'select-game',
    components: {
        PopupModal,
        CustomButton,
        Avatar
    },
    props: {
        games: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
        }
    },
    methods: {
        getTime(unix) {
            const now = Date.now();
            const expiredTime = now - unix;

            let time = '';

            if(expiredTime < 60000) time = 'zojuist'
            else if(expiredTime < 3600000) {
                let minutes = new Date(expiredTime).toLocaleString('nl-NL', { minute: 'numeric', timeZone: 'UTC' });
                if(minutes.substring(0, 1) === '0') minutes = minutes.substring(1, minutes.length);
                time = `${minutes} minuten geleden`;
            } 
            else if(expiredTime < 86400000) {
                let hours = new Date(expiredTime).toLocaleString('nl-NL', { hour: 'numeric', timeZone: 'UTC' });
                if(hours.substring(0, 1) === '0') hours = hours.substring(1, hours.length);
                time = `${hours} uur geleden`;
            } else time = '1 dag geleden'

            return time
        },
        handleSelectGame(id) {
            this.$emit('selectGame', id);
        }
    },
    computed: {
        sortedGames: function() {
            return this.games.sort((a, b) => a.creationDate < b.creationDate ? 1 : -1)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.games-wrapper {
    max-height: 50dvh;
    overflow: auto;

    .game-preview {
        border: 2px solid $weed-green;
        border-radius: 12px;
        // overflow: hidden;
        
        .content {
            padding: 12px 18px;

            .users-with-scores {
                display: flex;
                flex-direction: column;
                gap: 8px;

                .user {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    
                    .left {
                        display: flex;
                        align-items: center;
                        gap: 12px;

                        .avatar {
                            width: 36px;
                            height: 36px;
                        }
                    }


                    .score {
                        
                    }
                }
            }

            .creation-date {
                font-size: 14px;
                text-align: end;
                font-style: italic;
                margin-top: 6px;
            }
        }

        .footer {
            border-top: 2px solid $weed-green;
            padding-block: 6px;
            font-weight: 700;
            background: $weed-green;
            border-radius: 0 0 10px 10px;
        }
    }
}

</style>